import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsDocuments() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Documents' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure document settings here.</Text>
    </div>
  );
}
